<template>
    <div class="apply-menu-body">
        <div class="apply-menu">
            <div class="menu-head">
                <img class="head-logo" :src="$store.state.applyInfo.apply_logo" alt="logo"/>
            </div>
            <div class="menu-body">
                <ul class="menu-ul">
                    <li class="menu-ul-li" v-for="(item, index) in menuList" :key="index">
                        <div class="menu-item" :class="{'menu-active': index == selectID}" @click="handleMenuClick(index)">
                            <Icon :type="item.icon" size="20" v-if="item.icon_type == 0"/>
                            <i class="iconfont" :class="item.icon" v-else></i>
                            <span class="menu-name">{{ item.title }}</span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'ApplyMenu',
  data () {
    return {
      selectID: localStorage.getItem('APPLY_MENU') ? localStorage.getItem('APPLY_MENU') : 0,
      showSubMenu: false,
      menuList: [],
      isWatch: true
    }
  },
  watch: {
    $route (to, from) {
      if (!this.isWatch) return
      for (let i = 0; i < this.menuList.length; i++) {
        if (to.path == '/admin' + this.menuList[i].path) {
          this.handleMenuClick(i, false)
          break
        }
        if (this.menuList[i].children) {
          for (let j = 0; j < this.menuList[i].children.length; j++) {
            if (to.path == '/admin' + this.menuList[i].children[j].path) {
              this.handleMenuClick(i, false)
              break
            }
          }
        }
      }
    }
  },
  created () {
    // 初始化菜单
    this.initMenu()
  },
  methods: {
    initMenu () {
      // 初始化菜单
      let that = this
      this.requestApi('/adm/get_apply_menu').then(res => {
        if (res.status) {
          that.menuList = res.data
          that.updateSonMenu(res.data)
          if (res.data.length && typeof res.data[0].children !== 'undefined') {
            that.showSubMenu = true
          }
        }
      })
    },
    // 更新子菜单文本语言
    updateSonMenu (menuData) {
      let APPLY_MENU = localStorage.getItem('APPLY_MENU')
      if (APPLY_MENU != null && this.$store.state.showSubMenu) {
        if (menuData[APPLY_MENU].children) {
          this.$store.dispatch('setSubMenu', menuData[APPLY_MENU].children)
        }
      }
    },
    // 处理菜单点击事件
    handleMenuClick (position, isTo = true) {
      this.isWatch = false
      this.selectID = position // 更新选中的菜单索引

      let subMenu = this.menuList[position].children || [] // 获取子菜单
      let toPath = ''

      // 存成缓存
      localStorage.setItem('APPLY_MENU', position) // 缓存选中的菜单索引

      // 如果有子菜单，跳转到第一个子菜单的路径
      if (subMenu.length) {
        toPath = subMenu[0].path
        this.$store.dispatch('setSubMenu', subMenu) // 存储子菜单到 Vuex 中
        this.$store.dispatch('setShowSubMenu', true) // 显示子菜单
      } else {
        toPath = this.menuList[position].path
        this.$store.dispatch('setShowSubMenu', false) // 隐藏子菜单
        this.$store.dispatch('setSubMenu', []) // 清空子菜单
      }

      // 是否跳转
      if (isTo) {
        this.toUrl(toPath) // 跳转到菜单路径
      }

      setTimeout(() => {
        this.isWatch = true
      }, 200)
    }
  }
}
</script>

<style scoped>
.apply-menu-body {
    max-width: 200px;
    height: 100%;
    display: flex;
    flex-wrap: nowrap;
    background: #1f2d3d;
    position: relative;
}

.apply-menu {
    display: flex;
    flex-direction: column;
}

.menu-head {
    padding: 10px 14px;
    text-align: center;
}

.head-logo {
    width: 50px;
    height: 50px;
    border-radius: 25px;
}

.menu-body {
    flex: 2;
    overflow-y: auto;
    scrollbar-width: none;
}

.menu-body::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
}

.menu-ul {
    height: 100%;
    color: #515a6e;
}

.apply-menu {
    display: flex;
    flex-direction: column;
}

.menu-head {
    padding: 10px 14px;
    text-align: center;
}

.head-logo {
    width: 50px;
    height: 50px;
    border-radius: 25px;
}

.menu-body {
    flex: 2;
    overflow-y: auto;
    scrollbar-width: none;
}

.menu-body::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
}

.menu-ul {
    height: 100%;
    color: #515a6e;
}

.menu-ul-li {
    color: rgba(229, 229, 229, 1);
}

.menu-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 13px 0 7px 0;
    cursor: pointer;
}

.menu-active {
    background-color: #fff;
}

.menu-active i {
    color: rgba(31, 45, 61, 1);
}

.menu-name {
    padding: 0 24px;
    font-size: 14px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.menu-active .menu-name {
    color: rgba(31, 45, 61, 1);
}

.menu-item-selected .menu-name {
    color: #2d8cf0;
}

.iconfont {
    font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/menu/applyMenu.vue